<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'familymembertypes.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="familymembertypesGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'

export default {
  name: 'FamilymembertypesGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number',
          editable: false
        }
      },
      url: 'familymembertypes',
      preload: [],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '120px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px',
        editable: false
      },
      {
        field: 'name',
        title: 'Nome',
        width: '180px'
      },
      {
        field: 'state',
        title: 'Estado',
        width: '180px'
      },
      {
        field: 'age_min',
        title: 'Idade Min',
        width: '80px'
      },
      {
        field: 'age_max',
        title: 'Idade Max',
        width: '80px'
      },
      {
        field: 'color',
        title: 'Cor',
        width: '180px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('familymembertypes.edit')) {
        var route = router.resolve({
          name: 'familymembertypes.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      } else if (this.$auth.check('familymembertypes.view')) {
        var route = router.resolve({
          name: 'familymembertypes.view',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
